import { client } from "../client";

export async function verifyNotaryEstimationPhone(id: string, code: string): Promise<boolean> {
	return await client
		.post(`/_api_v0/notary-estimation/verify-phone/v1/${id}`, {
			json: {
				code,
			},
		})
		.json()
		.then((data: any) => data.verified);
}
